<!-- <app-cookie-consent></app-cookie-consent> -->
<div class="footer-container">
  <div class="copyright">
    <span> &copy; {{copyrightStartYear}}-{{year}} {{copyrightOrganisation}} |
      <a href="{{termsCondLink}}" target="_blank">{{'term_condition' | translate}}</a> </span>
  </div>
</div>
